exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-warehousing-batchpicks-create-batch-pick .modal-content{font-size:10pt}#modal-warehousing-batchpicks-create-batch-pick .modal-dialog{width:75vw!important;max-width:75vw!important}", ""]);

// exports
